<template>
	<div class="page-building page-content" v-loading="body_loading">
		<div class="main-body">
			<el-row class="hd">
				<el-col :span="12">
					<h3 style="float: none;">楼宇管理</h3>
					<div class="flex-block breadcrumb-box">
						<div class="position-text">位置：</div>
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item>基础配置</el-breadcrumb-item>
							<el-breadcrumb-item>楼宇列表</el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</el-col>
				<el-col :span="12" class="text-right" style="padding: 11px 24px 11px 0;">
					<el-button type="primary" class="btn-bg-p" @click="handleItem('add')">添加 <i class="el-icon-plus"></i></el-button>
				</el-col>
			</el-row>
			<div class="bd">
				<div class="table-block content-body">
					<div ref="contentBody">
						<el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
							<el-table-column prop="name" align="center" label="楼宇名称" min-width="160"></el-table-column>
							<el-table-column prop="managerNames" align="center" label="管理员" min-width="160"></el-table-column>
							<el-table-column prop="showOrder" align="center" label="排序" min-width="100"></el-table-column>
							<el-table-column prop="createdate" align="center" label="创建时间" min-width="160"></el-table-column>
							<el-table-column prop="operating" align="center" label="操作" min-width="200" fixed="right">
								<template slot-scope="scope">
									<el-button class="option-btn btn-bd-s" type="primary" size="mini" @click="handleItem('edit',scope.row)">编辑</el-button>
									<el-button class="option-btn btn-bd-r" type="primary" size="mini" @click="deleteItem(scope.row.icode)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="table_data.page_info.page" :page-sizes="[10,30,50,80,100]" :page-size="table_data.page_info.pageSize" layout="total, sizes, prev, pager, next" :total="table_data.page_info.total"></el-pagination>
				</div>
			</div>
		</div>
		<el-dialog class="dialog-export" :title="dlg_item.title" :visible.sync="dlg_item.visible" width="534px" @close="closeDialog" :close-on-click-modal="false">
			<el-form ref="formItem" :model="dlg_item.form" label-width="120px" :rules="dlg_item.rules" @submit.native.prevent>
				<el-form-item prop="name" label="楼宇名称：">
					<el-input size="small" v-model="dlg_item.form.name" placeholder='请输入楼宇名称' clearable></el-input>
				</el-form-item>
				<el-form-item prop="managerIds" label="管理员：">
					<el-select size="small" v-model="dlg_item.form.managerIds" multiple filterable placeholder="请输入用户名搜索" :loading="dlg_item.user_loading" style="width:100%;">
						<el-option v-for="item in dlg_item.user_list" :key="item.icode" :label="item.userName" :value="item.icode"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="showOrder" label="排序：">
					<el-input size="small" type='number' v-model="dlg_item.form.showOrder" placeholder='请输入排序' clearable></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dlg_item.visible = false">取 消</el-button>
				<el-button type="primary" @click="submitItem()" :loading="dlg_item.btn_loading">确认</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	name: 'buildingList',
	data() {
		return {
			body_loading: false,
			table_data: {
				loading: false,
				list: [],
				page_info: {
					page: 1,
					pageSize: 10,
					total: 0
				}
			},
			dlg_item: {
				visible: false,
				btn_loading: false,
				user_loading: false,
				title: '',
				api: '',
				form: {
					id: '',
					icode: '',
					name: '',
					managerIds: [],
					showOrder: 0
				},
				user_list: [],
				reset_form: {},
				rules: {
					name: {required: true, message: '请输入楼宇名称', trigger: ['change','blur']},
					showOrder: {required: true, message: '请输入排序', trigger: ['change','blur']}
				}
			}
		}
	},
	created() {
		document.title = '楼宇管理';
		this.dlg_item.reset_form = Object.assign({}, this.dlg_item.form);
		this.getList();
		this.getUserList();
	},
	methods: {
		getUserList() {
			var _this = this;
			var params = {pageNo: 1, pageSize: 9999};
			this.$client.get('/api/sys/user/getListForAdmin', params, function(res) {
				_this.dlg_item.user_list = res;
			});
		},
		getList() {
			var _this = this;
			var params = {
				pageNo: _this.table_data.page_info.page,
				pageSize: _this.table_data.page_info.pageSize
			};
			_this.table_data.loading = true;
			this.$client.get('/api/biz/building/info/getList', params, function(res, message, total) {
				_this.table_data.list = res;
				_this.table_data.page_info.total = total;
				_this.table_data.loading = false;
			}, function(res) {
				_this.table_data.loading = false;
			});
		},
		handleSizeChange(val) {
			this.table_data.page_info.pageSize = val;
			this.getList();
		},
		handleCurrentChange(val) {
			this.table_data.page_info.page = val;
			this.getList();
		},
		handleItem(type, data) {
			this.dlg_item.visible = true;
			if (type == 'add') {
				this.dlg_item.title = '添加楼宇';
				this.dlg_item.api = '/api/biz/building/info/save';
			} else {
				this.dlg_item.title = '编辑楼宇';
				this.dlg_item.api = '/api/biz/building/info/save';
				this.dlg_item.form.id = data.id;
				this.dlg_item.form.icode = data.icode;
				this.dlg_item.form.name = data.name;
				this.dlg_item.form.showOrder = data.showOrder;
				if (data.managerIds) {
					this.dlg_item.form.managerIds = data.managerIds.split(',');
				}
			}
		},
		deleteItem(id) {
			var _this = this;
			this.$confirm('确定要删除？', "", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				iconClass: "icon-delete el-icon-delete",
				customClass: "my-confirm-box",
				center: true
			}).then(() => {
				_this.$client.post('/api/biz/building/info/delete', {id: id}, function(res, message) {
					_this.$message(message);
					_this.getList();
				});
			}).catch(() => {});
		},
		submitItem() {
			var _this = this;
			_this.$refs['formItem'].validate((valid) => {
				if (valid) {
					var submitData = Object.assign({}, _this.dlg_item.form);
					submitData.managerIds = submitData.managerIds.join(',');
					var names = [];
					_this.dlg_item.user_list.forEach(u => {
						if (_this.dlg_item.form.managerIds.includes(u.icode)) {
							names.push(u.userName);
						}
					});
					submitData.managerNames = names.join(',');
					_this.dlg_item.btn_loading = true;
					_this.$client.post(_this.dlg_item.api, submitData, function(res, message) {
						_this.$message(message);
						_this.getList();
						_this.dlg_item.btn_loading = false;
						_this.dlg_item.visible = false;
					}, function(message) {
						_this.dlg_item.btn_loading = false;
					});
				}
			});
		},
		closeDialog() {
			for (var key in this.dlg_item.form) {
				this.dlg_item.form[key] = this.dlg_item.reset_form[key];
			}
			this.$nextTick(() => {
				this.$refs.formItem.clearValidate();
			});
		}
	}
}
</script>
